import { Injectable } from '@angular/core';
import { RouterStateSnapshot, CanActivate } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RoutingService } from '@app/core/services/routing.service';
import { loggedExceptionUrl } from '@app/shared/guards/exception-routes';

@Injectable()
export class AuthenticateExternalLinkGuard implements CanActivate {
  constructor(private routingService: RoutingService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Check route : if route is an external link to be auth
    if (loggedExceptionUrl.includes(state.url)) {
      this.routingService.failover(state.url);
    }
    return false;
  }
}
